module.exports = __webpack_public_path__ + "static/media/painting.a5758726.svg";